<template>
  <div class="row">
    <div class="col-md-12">
      <dashboard-box :back="true" back-component-name="management.service_statuses.index">
        <template v-slot:title>
          <span>{{ $t("service_statuses.users") }}</span>
        </template>
        <template v-slot:preview>
          <b-row>
            <b-col lg="6" md="6" sm="12" xl="6" v-for="(item, index) in form.translations" :key="index">
              <b-form-group :label="`${$t('service_statuses.name')} (${getLanguageById(item.language_id).name})`">
                <b-form-input
                    v-model="item.name"
                    :placeholder="$t('service_statuses.name')"
                    :state="validateState(index)"
                    class="form-control form-control-solid"
                    name="name"
                    type="text"
                ></b-form-input>
                <b-form-invalid-feedback
                    v-if="!validateState(index) && !$v.form.translations.$each[index].name.required"
                    :state="true">
                  {{ $t('service_statuses.validations.name.required') }}
                </b-form-invalid-feedback>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('service_statuses.color')">
                <v-swatches
                    v-model="form.color"
                    show-fallback
                    fallback-input-type="color"
                    popover-x="right"
                ></v-swatches>
              </b-form-group>
            </b-col>

            <b-col lg="6" md="6" sm="12" xl="6">
              <b-form-group :label="$t('service_statuses.status')">
                <b-form-checkbox v-model="form.status" name="check-button" switch>
                </b-form-checkbox>
              </b-form-group>
            </b-col>

            <b-col
                class="float-right text-right"
                lg="12"
                md="12"
                sm="12"
                xl="12"
            >
              <b-button
                  class="mr-1"
                  variant="secondary"
                  @click="goBack"
              >
                <i class="fas fa-arrow-left"></i>
                {{ $t("general.cancel") }}
              </b-button>
              <b-button variant="primary" @click="createOrUpdate()">
                <i class="far fa-save"></i>
                {{ $t(id != null ? "general.save" : "general.create") }}
              </b-button>
            </b-col>
          </b-row>
        </template>
      </dashboard-box>
    </div>
  </div>
</template>
<script>
import DashboardBox from "@/assets/components/DashboardBox";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";

import baseModule, {
  BASE_URL,
  CREATE_ITEM,
  ERROR,
  GET_ITEM,
  ITEM,
  LOADING,
  MODULE_NAME,
  SUCCESS,
  UPDATE_ITEM
} from "@/core/services/store/serviceStatus.module";
import store from "@/core/services/store";
import {validationMixin} from "vuelidate";
import {required} from "vuelidate/lib/validators";
import VSwatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.css'

const _MODULE_NAME = MODULE_NAME;

export default {
  name: "TeamTypeCreateEdit",
  mixins: [validationMixin],
  beforeCreate() {
    function registerStoreModule(moduleName, storeModule) {
      if (!(store && store.state && store.state[moduleName])) {
        store.registerModule(moduleName, storeModule);
      }
    }

    registerStoreModule(_MODULE_NAME, baseModule);
  },
  components: {
    DashboardBox,
    VSwatches
  },
  validations: {
    form: {
      translations: {
        $each: {
          name: {
            required
          }
        }
      },
      status: {
        required
      }
    }
  },
  computed: {
    error() {
      return store.getters[_MODULE_NAME + "/" + ERROR];
    },
    loading() {
      return store.getters[_MODULE_NAME + "/" + LOADING];
    },
    success() {
      return store.getters[_MODULE_NAME + "/" + SUCCESS];
    },
    item() {
      return store.getters[_MODULE_NAME + "/" + ITEM];
    }
  },
  data() {
    return {
      id: this.$route.params.id,
      form: {
        color: '#000000',
        status: true,
        translations: [],
      }
    };
  },
  methods: {
    goBack() {
      this.$router.push({name: "management.service_statuses"})
    },
    validateState(index) {
      const {$dirty, $error} = this.$v.form.translations.$each[index].name
      return $dirty ? !$error : null;
    },
    getItem() {
      this.$store
          .dispatch(_MODULE_NAME + "/" + GET_ITEM, {
            url: BASE_URL + "/" + this.id,
          })
    },
    createOrUpdate() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        return;
      }

      let formData = _.clone(this.form);

      if (this.form.status) {
        formData.status = 1;
      } else {
        formData.status = 0;
      }

      if (this.id) {
        this.$store
            .dispatch(_MODULE_NAME + "/" + UPDATE_ITEM, {
              url: BASE_URL + "/" + this.id,
              contents: formData
            });
      } else {
        this.$store
            .dispatch(_MODULE_NAME + "/" + CREATE_ITEM, {
              url: BASE_URL,
              contents: formData,
            });
      }
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      {title: this.$t("general.dashboard"), route: "dashboard"},
      {title: this.$t(this.id ? "service_statuses.edit_item" : "service_statuses.create_item")}
    ]);

    if (this.id) {
      this.getItem();
    } else {
      let languages = this.systemLanguages;
      let self = this;
      languages.forEach(item => {
        self.form.translations.push({
          language_id: item.id,
          name: "",
        })
      })
    }
  },
  watch: {
    item(value) {
      if (value) {
        let item = value;
        if (item.status) {
          item.status = true;
        } else {
          item.status = false;
        }
        this.form = item;
      }
    },
    success(value) {
      let self = this;
      if (value) {
        setTimeout(() => {
          self
              .sweetAlertSuccess(self.$t("general.successfully_saved"), (response) => {
                if (response) {
                  self.$router.push({ name: "management.service_statuses"});
                }
              });
        }, 500)
      }
    }
  }
};
</script>

<style scoped>
#dashboard-box {
  padding: 10px;
}
</style>
